import moment from "jalali-moment";

export const convertDate = (date, withHoure = false) => {
  if (date) {
    const format = withHoure ? "jYYYY/jMM/jDD (HH:mm:ss)" : "jYYYY/jMM/jDD";
    const shamsi = moment(date).format(format);
    return shamsi;
  } else {
    return "-";
  }
};
